"use strict";
exports.__esModule = true;
exports.Tokens = exports.StructuralCharacters = exports.Operators = void 0;
var Operators;
(function (Operators) {
    Operators["AND"] = "AND";
    Operators["OR"] = "OR";
    Operators["XOR"] = "XOR";
    Operators["NOT"] = "NOT";
})(Operators = exports.Operators || (exports.Operators = {}));
var StructuralCharacters;
(function (StructuralCharacters) {
    StructuralCharacters["OPEN_PARENTHESIS"] = "(";
    StructuralCharacters["CLOSE_PARENTHESIS"] = ")";
})(StructuralCharacters = exports.StructuralCharacters || (exports.StructuralCharacters = {}));
var Tokens;
(function (Tokens) {
    Tokens["IDENTIFIER"] = "IDENTIFIER";
    Tokens["OPERATOR"] = "OPERATOR";
    Tokens["STRUCTURAL_CHARACTER"] = "STRUCTURAL_CHARACTER";
    Tokens["EOF"] = "EOF";
    Tokens["COMMENT"] = "COMMENT";
})(Tokens = exports.Tokens || (exports.Tokens = {}));
